import { Icon, Tooltip } from 'antd';
import styles from './LimitsPermitBtn.module.scss';
import React from 'react';
import { modalType, useModal } from '../../modalProvider';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';

const LimitsPermitBtn = () => {
  const math = useTransportPermitsMatch();

  const { open } = useModal(modalType.LIMITS_PERMIT_MODAL);

  const { params } = math || {};

  return (
    <Tooltip title="Лимиты пропусков">
      <div
        onClick={() => open({ companyId: params?.companyId })}
        className={styles.root}
      >
        <Icon type="setting" style={{ color: '#0995ed', fontSize: '20px' }} />
      </div>
    </Tooltip>
  );
};

export default LimitsPermitBtn;
